// extracted by mini-css-extract-plugin
export default {"m":"StandItem_m__lgR1Z","n":"StandItem_n__XLNqe","d":"StandItem_d__hbfmJ"};